/* eslint-disable camelcase */
import React, { useState } from 'react';

import { useRouter } from 'next/router';

import { useMembership } from '~/techstyle-shared/react-accounts';

import useBuilderConstructorGridInputs from '../hooks/useBuilderConstructorGridInputs';
import useCioBrowseAndGqlProducts from '../hooks/useCioBrowseAndGqlProducts';
import {
  getSanitizedSortOptions,
  isSortOptionSelected,
  updateSortInUrlParams,
} from '../utils/sortOptions';

const DesktopGridSortDropdown = () => {
  const [open, setOpen] = useState(false);
  const router = useRouter();
  const { isVip } = useMembership();

  const { sortOptions: builderSortOptions } = useBuilderConstructorGridInputs();
  const { cioSortOptions } = useCioBrowseAndGqlProducts();

  if (!cioSortOptions) {
    return null;
  }

  const selectedSortOption = cioSortOptions?.find(({ status }) =>
    isSortOptionSelected({ status })
  );

  const sanitizedSortOptions = getSanitizedSortOptions({
    builderSortOptions,
    cioSortOptions,
    isVip,
    excludeSelectedOption: true,
  });

  const handleSortOptionClick = ({ sort_by }) => {
    updateSortInUrlParams({
      router,
      sort: sort_by,
    });

    setOpen(false);
  };

  return (
    <div>
      <button
        type="button"
        className="border-black border-[1px] p-1"
        onClick={() => {
          setOpen((open) => !open);
        }}
      >
        Sort by: {selectedSortOption?.display_name}
      </button>
      {open && (
        <ul>
          {sanitizedSortOptions?.map(({ display_name, sort_by }) => (
            <li key={sort_by}>
              <button
                type="button"
                className="border-black border-[1px] p-1 hover:bg-gray-200"
                onClick={() => handleSortOptionClick({ sort_by })}
              >
                {display_name}
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default DesktopGridSortDropdown;
